import { FC, useEffect, useState } from "react";
import { formatAvailabilityDisplay } from "../../../../services/candidateJobsService";
import { useAppSelector as useSelector } from "../../../../store";
import EditJobPreferences from "../../../OnboardingSteps/CompletedProfile/edit-forms/EditJobPreferences";
import EditPencil from "../../../UI/Icons/EditPencil";
import Filter from "../../../UI/Icons/Filter";
import KmSelector from "../../../UI/KmSelector";
import PopupModal from "../../../UI/Popup";
import Availabilities from "../../Availabilities";

const MyPreference: FC<{selectedDistancyAway: number, setSelectedDistancyAway: React.Dispatch<React.SetStateAction<number>>}> = ({selectedDistancyAway, setSelectedDistancyAway}) => {
  const jobPreference = useSelector((state) => state.onboarding.jobpreferences);

 
  const [totalSuburbs, setTotalSuburbs] = useState<number>(0);
  const [showJobPreferenceEditModal, setShowJobPreferenceEditModal] =
    useState<boolean>(false);
  const [showAvailabilityEditModal, setShowAvailabilityEditModal] =
    useState<boolean>(false);
  const [isEditingDistance, setIsEditingDistance] = useState<boolean>(false);
  
  const availabilitiesFromProfile = useSelector(
      (state) => state.onboarding.availabilities
  );

  useEffect(() => {
    if (
      jobPreference !== null &&
      jobPreference?.jobpreferencesubrubs.length > 0
    ) {
      setTotalSuburbs(jobPreference?.jobpreferencesubrubs.length);
    }
  }, [jobPreference, jobPreference?.jobpreferencesubrubs]);

  const handleAvailability = () => {
    setShowAvailabilityEditModal(!false);
  };

  const handleJobPreference = () => {
    setShowJobPreferenceEditModal(!false);
  };

  const handleEditDistance = () => {
    setIsEditingDistance(true);
  };

  const handleDistanceClose = () => {
    setIsEditingDistance(false);
  };

  const onClickClose = () => {
    setShowJobPreferenceEditModal(false);
    setShowAvailabilityEditModal(false);
  };

  const handleRoles = () => {};
  const handleOpenMapView = () => {};

  const handleOpenMaxDistanceAway = () => {
    setIsEditingDistance(!isEditingDistance);
  };

  return (
    <>
      <PopupModal
        visible={showJobPreferenceEditModal}
        showCloseBtn={true}
        onClickClose={onClickClose}
      >
        <EditJobPreferences handleClose={setShowJobPreferenceEditModal} isMyPreference={true}/>
      </PopupModal>

      <PopupModal
        visible={showAvailabilityEditModal}
        showCloseBtn={true}
        onClickClose={onClickClose}
      >
        <Availabilities
          setShowAvailabilitiesModal={setShowAvailabilityEditModal}
          isFromMyPreference={true}
        />
      </PopupModal>

      <div className="bg-teal-pale p-10 radius-8px border border-grey-light d-flex flex-column flex-lg-row gap-25 justify-content-lg-between align-items-lg-center">
        <div className="d-flex flex-column flex-lg-row gap-25 align-items-lg-center">
          <div className="d-flex gap-10 align-items-center">
            <Filter />
            <div className="fs-16 fw-700 text-teal-dark">My Preferences:</div>
          </div>
          <div className="d-flex gap-3 align-items-center lh-1">
            <div className="fs-13 fw-400 text-black cursor-pointer" role="button" onClick={handleAvailability}>Availability</div>
            <div className="fs-13 fw-700 text-black cursor-pointer" role="button" onClick={handleAvailability}>{formatAvailabilityDisplay(availabilitiesFromProfile)}</div>
            <div className="cursor-pointer" onClick={handleAvailability}>
              <EditPencil size={15} />
            </div>
          </div>
          <div className="d-flex gap-3 align-items-center lh-1">
            <div className="fs-13 fw-400 text-black cursor-pointer" onClick={handleOpenMaxDistanceAway}>Maximum distance away</div>
            <KmSelector
              selectedDistancyAway={selectedDistancyAway}
              setSelectedDistancyAway={setSelectedDistancyAway}
              isEditing={isEditingDistance}
            />
          </div>
          <div className="d-flex gap-3 align-items-center lh-1 cursor-pointer" onClick={handleJobPreference}>
            <div className="fs-13 fw-400 text-black cursor-pointer">Suburbs</div>
            <div className="fs-13 justify-content-center align-items-center fw-700 text-black">
              {totalSuburbs}
            </div>
            <div className="cursor-pointer">
              <EditPencil size={15} />
            </div>
          </div>
          {/* <div className="d-flex gap-3 align-items-center lh-1">
            <div className="fs-13 fw-400 text-black">Roles</div>
            <div className="fs-13 fw-700 text-black">{"Casual Only"}</div>
            <div className="cursor-pointer" onClick={handleRoles}>
              <EditPencil size={15} />
            </div>
          </div> */}
        </div>
        {/* <div className="d-flex">
          <CustomButton
            variant="primary"
            type="submit"
            onClick={handleOpenMapView}
            contentClass="d-flex"
            className="btn-theme bg-dark text-white fs-16 fw-400 radius-8px px-14px max-h-30px"
          >
            <Location color="#ffffff" />
            Map View
          </CustomButton>
        </div> */}
      </div>
    </>
  );
};

export default MyPreference;
